import { configFetch as fetch } from '@laigu/utils';

export const getAgentListApi = () => {
  return fetch({
    url: `/agent/agents?_${new Date().getTime()}`,
    type: 'get'
  });
};

export const changeAgentStatusApi = ({ agentId, status }) => {
  return fetch({
    url: `/agent/agents/${agentId}/status`,
    method: 'PUT',
    data: {
      status
    }
  });
};

export const handleAgentOfflineApi = agentId =>
  fetch({
    url: `/agent/kick_person_offline`,
    method: 'post',
    data: {
      agent_id: agentId
    }
  });
